module.exports = __webpack_public_path__ + "static/media/DNA.f4b95a55.svg";